import authButton from './index.vue'
const authButtonComponent = {
  install: function (Vue) {
    Vue.component('authButton', authButton)
  }
}
export default authButtonComponent
